import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/download_pattern_left.png'
import _imports_1 from '@/assets/images/download_pattern_right.png'
import _imports_2 from '@/assets/images/ic_launcher_2.png'


const _hoisted_1 = { class: "app-download" }
const _hoisted_2 = { class: "down-box" }
const _hoisted_3 = { class: "btn-item" }
const _hoisted_4 = { class: "down-btn" }
const _hoisted_5 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_6 = { class: "btn-item" }
const _hoisted_7 = { class: "down-btn" }
const _hoisted_8 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_9 = { class: "down-box-1" }
const _hoisted_10 = { class: "btn-item-1" }
const _hoisted_11 = { class: "btn-item-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createStaticVNode("<span class=\"pattern left\" data-v-82799642><img src=\"" + _imports_0 + "\" data-v-82799642></span><span class=\"pattern right\" data-v-82799642><img src=\"" + _imports_1 + "\" data-v-82799642></span><div class=\"title-box\" data-v-82799642><p class=\"name\" data-v-82799642>Ai Bed</p><p class=\"desc\" data-v-82799642> Delete account! </p></div><div class=\"imgdiv\" data-v-82799642><img src=\"" + _imports_2 + "\" alt=\"\" style=\"border-radius:15px;\" data-v-82799642></div>", 4)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { style: {"width":"80px","display":"inline-block"} }, " Email: ", -1)),
        _createElementVNode("span", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            style: {"border":"none","background":"transparent","width":"13.5rem","height":"2.25rem","text-align":"center"},
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event))
          }, null, 512), [
            [_vModelText, $setup.email]
          ])
        ]),
        (!$setup.isValid)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Email format incorrect"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { style: {"width":"80px","display":"inline-block"} }, " Captcha: ", -1)),
        _createElementVNode("span", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            style: {"border":"none","background":"transparent","width":"13.5rem","height":"2.25rem","text-align":"center"},
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.captcha) = $event))
          }, null, 512), [
            [_vModelText, $setup.captcha]
          ])
        ]),
        (!$setup.isCaptcha)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Incorrect Captcha"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", {
          class: "down-btn-1",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.sendCaptcha()))
        }, _toDisplayString($setup.oneMinute != 60 ? $setup.oneMinute + "s" : "Send Captcha"), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", {
          class: "down-btn-1",
          style: {"background-color":"red"},
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.deleteAccount()))
        }, " Delete account ")
      ])
    ])
  ]))
}